angular.module('pipNavMenu', ['ngMaterial', 'pipNav.Translate', 'pipNav.Templates']);

import './NavMenuService';
import './NavMenu';